import AppContext, { AppContexts } from "components/app-context";
import { useContext, useMemo } from "react";

export const useIsEditor = (): boolean => {
	const appContext = useContext(AppContext);
	return useMemo(() => {
		return appContext === AppContexts.admin;
	}, [appContext]);
};